import React from 'react';
import { styled } from '@linaria/react';
import { useDefaultLayout } from 'hooks/useDefaultLayout';
import { ANIMATION_TYPES, Overlay } from '@daedalus/atlas/Overlay';
type Props = {
  mapComponent: React.ReactNode;
};
const Wrapper = /*#__PURE__*/styled('main')({
  name: "Wrapper",
  class: "w10exn0s",
  propsAsIs: false
});
export const MapOverlay = ({
  mapComponent
}: Props) => {
  const {
    isMapVisible
  } = useDefaultLayout();
  return <Overlay isOpen={isMapVisible} shadeBackground={false} animationType={ANIMATION_TYPES.FADE_IN_OUT}>
      <Wrapper>{mapComponent}</Wrapper>
    </Overlay>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");